<template>
  <transition name="fade">
    <div
      v-if="isValidAttemptsRemainingNumber"
      class="attempt-warning"
      :class="[
        { 'attempt-warning__warning': isValidAttemptsRemainingNumber && hasAttemptsRemaining },
        { 'attempt-warning__error': isValidAttemptsRemainingNumber && !hasAttemptsRemaining },
      ]"
    >
      <v-icon class="attempt-warning__icon">warning</v-icon>
      <p
        v-if="isValidAttemptsRemainingNumber && hasAttemptsRemaining"
        class="attempt-warning__text"
      >
        <span class="text--semibold">{{ $t(`${namespace}.incorrectPassword`) }}</span> {{ $t(`${namespace}.attemptsMessage`).replace('[VAL]', attemptsRemaining) }}
      </p>

      <p
        v-if="isValidAttemptsRemainingNumber && !hasAttemptsRemaining"
        class="attempt-warning__text"
      >
        <span class="text--semibold">{{ $t(`${namespace}.exhaustedAttempts`) }}</span> {{ $t(`${namespace}.resetPasswordMessage`) }}
      </p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LoginAttemptsWarning',
  props: {
    attemptsRemaining: {
      type: [Number, String]
    }
  },
  computed: {
    isValidAttemptsRemainingNumber () {
      return typeof this.attemptsRemaining === 'number'
    },

    hasAttemptsRemaining () {
      return this.attemptsRemaining > 0
    }
  },
  data () {
    return {
      namespace: 'Components.LoginAttemptsWarning'
    }
  }
}
</script>

<style lang="scss" scoped>
.attempt-warning {
  align-items: center;
  background-color: var(--attention);
  border-bottom: 1px solid var(--gray-4);
  display: flex;
  justify-content: center;
  justify-items: center;
  left: 0;
  min-height: 60px;
  padding: 0 16px;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 1000;

  &.attempt-warning__warning {
    background-color: var(--attention);

    .attempt-warning__icon {
      color: var(--warning-2) !important;
    }
  }

  &.attempt-warning__error {
    background-color: var(--error-2);

    .attempt-warning__icon {
      color: var(--error) !important;
    }

    .attempt-warning__text {
      color: #a94442;

      span {
        color: var(--error);
      }
    }
  }
}

.attempt-warning__text {
  margin: 0;

  span {
    color: var(--gray-8);
    font-weight: 600;
  }
}

.attempt-warning__icon {
  margin-right: 8px;
}
</style>
